<loading [loading]="loading.isShow" [loadingMessage]="loading.message"></loading>

<div [hidden]="loading.isShow">
  <ng-container *ngIf="error_messages.length > 0">
    <ng-container *ngFor="let error_message of error_messages">
      <div class="alert alert-danger">
        <button type="button" class="close" data-dismiss="alert" (click)="removeErrorMessage(error_message)">
          ×
        </button>
        {{ error_message }}
      </div>
    </ng-container>
  </ng-container>

  <div [hidden]="!login">
    <div class="loginmodal-container">
      <h1>Log in to your signNow account</h1>
      <br />
      <form>
        <input type="text" name="user" class="sn-sf-input" placeholder="Email" #emailInput />
        <input type="password" name="pass" class="sn-sf-input" placeholder="Password" #passwordInput />
        <div class="loginmodal-container__controls">
          <button
            class="btn btn-primary full-width"
            (click)="loginUser(emailInput.value, passwordInput.value)"
          >
            Login
          </button>
          <sn-sso-login-btn (loginEvent)="reloadAfterSSOLogin()"></sn-sso-login-btn>
          <div class="tac create-account">
            <span>No account?&nbsp;</span>
            <a
              class="create-account__link"
              href="https://snseats.signnow.com/purchase/business_free_trial/loggedout?source=salesforce"
              target="_blank"
            >
              Sign up for signNow for free
            </a>
          </div>
        </div>
      </form>
    </div>
  </div>

  <div [hidden]="login">
    <div *ngIf="refresh == true" class="alert alert-warning alert-dismissible fade show" role="alert">
      <strong>Reload!</strong>
      After editing and saving the document click the Reload button.
      <button type="button" class="btn btn-warning" (click)="reload_view()">Reload</button>
    </div>

    <button class="btn btn-primary log-out-btn" (click)="logoutUser()">Logout</button>

    <Modal-Attachments [hidden]="edit_document">
      <Modal-Attachments-Header>
        <h2 id="id-of-modalheader-h2" class="slds-text-heading_medium">Options</h2>
      </Modal-Attachments-Header>
      <Modal-Attachments-Content>
        <div class="row">
          <div class="col-md templates-container">
            <div class="panel panel-default panel-table">
              <div class="panel-heading">
                <div class="row">
                  <div class="col">
                    <input
                      type="text"
                      (keyup)="searchDocuments(search.value, 'documentsTable')"
                      class="sn-sf-input"
                      id="search"
                      placeholder="Search Documents in the Group"
                      #search
                    />
                    <span class="glyphicon glyphicon-search search-icon"></span>
                    <ng-container *ngIf="okay_to_generate_document_group">
                      <button
                        type="button"
                        (click)="documentGroupNamePopup()"
                        class="btn btn-primary floating_button document-group"
                      >
                        Generate Document Group
                      </button>
                    </ng-container>
                  </div>
                </div>
              </div>
              <div class="panel-body">
                <div class="scrolling">
                  <table class="table table-bordered table-list" id="documentsTable" #documentstable>
                    <tbody>
                      <ng-container *ngFor="let folder of folders">
                        <tr>
                          <td colspan="4">
                            <span class="glyphicon glyphicon-folder-open"></span>
                            &nbsp;&nbsp;{{ folder.name }}
                            <b *ngIf="folder.documents?.length === 0"> - Empty </b>
                          </td>
                        </tr>
                        <ng-container *ngFor="let document of folder.documents; let i = index">
                          <tr [attr.data-index]="i">
                            <td style="text-align: center">
                              <input
                                checked
                                disabled
                                type="checkbox"
                                class="slds-checkbox"
                                (change)="addToDocumentGroup(document, $event)"
                              />
                            </td>
                            <td>
                              <span class="glyphicon glyphicon-file"></span>&nbsp;&nbsp;
                              {{ document.document_name }}
                            </td>
                            <td>
                              {{ document.owner }}
                            </td>
                            <td data-label="Update Invite" class="dropdown-templates">
                              <div title="Update Invite">
                                <select
                                  class="sn-sf-input full-width"
                                  id="selectElem"
                                  #selectElem
                                  (change)="selectedDocumentSettings(selectElem, document)"
                                >
                                  <option>Select An Option</option>
                                  <option value="edit">Edit Document</option>
                                  <option value="annotations">Salesforce Annotations</option>
                                  <option value="pushback">Salesforce Data Binding</option>
                                </select>
                              </div>
                            </td>
                          </tr>
                        </ng-container>
                      </ng-container>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal-Attachments-Content>
    </Modal-Attachments>

    <app-data-binding-popup-form
      *ngIf="is_show_pushback_popup"
      (hideAllModalsE)="hideAllModals()"
      (updateLoadingE)="updateLoadingEvent($event)"
      (addPushbackDataToDocumentE)="addPushbackDataToDocument()"
      (resetDataAndUpdateErrorE)="resetDataAndUpdateErrorEvent($event)"
      [recordType]="pushbackType"
      [isNeedShowForm]="display_pushback"
      [document]="selected_pushback_document"
      [sfObjectsSuggestionList]="sfObjectsList"
      [isUserOwnerOfDocument]="is_user_owner_of_selected_document"
    >
    </app-data-binding-popup-form>

    <sn-modal-popup [isShowModal]="group_popup">
      <ng-container class="sn-modal-header">
        <h2 id="modal-heading-01" class="slds-text-heading_medium slds-hyphenate">
          Generate new Document Group
        </h2>
      </ng-container>
      <ng-container class="sn-modal-content">
        <div class="form-group">
          <label
            for="DocumentGroupInput"
            class="col-md-6 control-label"
            style="font-size: 0.9rem; margin-top: 5px"
          >
            Please enter document group name:
          </label>
          <div class="col-md-6">
            <input
              type="text"
              class="sn-sf-input full-width"
              id="DocumentGroupInput"
              value="{{ new_document_group_name }}"
              #DocumentGroupNameInput
            />
          </div>
        </div>
      </ng-container>
      <ng-container class="sn-modal-footer">
        <button class="btn btn-primary" (click)="generateDocumentGroup(DocumentGroupNameInput.value)">
          Submit
        </button>
        <button class="btn btn-neutral" (click)="cancelGenerateGroup(isShowDocGroupTemplates)">Cancel</button>
      </ng-container>
    </sn-modal-popup>

    <ng-container *ngIf="edit_document">
      <div class="slds-modal-wrap">
        <div
          role="dialog"
          tabindex="-1"
          aria-labelledby="modal-heading-01"
          class="slds-modal slds-fade-in-open"
          style="width: 100%; top: 0; bottom: 0; padding: 0"
        >
          <div class="slds-modal__container" style="width: 100%; max-width: 100%; height: 100%">
            <div class="slds-modal__content overhide" id="modal-content" style="height: 100%; width: 100%">
              <object width="100%" height="100%" [data]="edit_document_url"></object>
            </div>
          </div>
        </div>
        <div class="slds-backdrop slds-backdrop_open"></div>
      </div>
    </ng-container>
  </div>
</div>
